import { PromoterModel } from '@mm/state/model/PromoterModel';

export default (guard: PromoterModel, chatbotId: number): PromoterModel => ({
  ...guard,
  ...{
    botId: chatbotId,
    description: 'Default description',
    type: guard.type,
  },
});
